// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__1-v0w","image-wrapper":"styles-m__image-wrapper__1zdOv","content":"styles-m__content__38B88","headline":"styles-m__headline__PHcyl"};